function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.98001 10.072L5.14801 9.512L6.16401 8.288L4.70001 7.848L5.01201 6.936L6.40401 7.52L6.33201 6H7.36401L7.29201 7.52L8.68401 6.936L8.99601 7.848L7.53201 8.288L8.54001 9.512L7.70801 10.064L6.84401 8.768L5.98001 10.072ZM11.1047 10.072L10.2727 9.512L11.2887 8.288L9.8247 7.848L10.1367 6.936L11.5287 7.52L11.4567 6H12.4887L12.4167 7.52L13.8087 6.936L14.1207 7.848L12.6567 8.288L13.6647 9.512L12.8327 10.064L11.9687 8.768L11.1047 10.072ZM16.2293 10.072L15.3973 9.512L16.4133 8.288L14.9493 7.848L15.2613 6.936L16.6533 7.52L16.5813 6H17.6133L17.5413 7.52L18.9333 6.936L19.2453 7.848L17.7813 8.288L18.7893 9.512L17.9573 10.064L17.0933 8.768L16.2293 10.072Z",
  fill: "current"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 0C0.895447 0 0 0.895432 0 2V14C0 15.1046 0.895447 16 2 16H22C23.1046 16 24 15.1046 24 14V2C24 0.895432 23.1046 0 22 0H2ZM2 1.39999C1.66864 1.39999 1.40002 1.66862 1.40002 2V14C1.40002 14.3314 1.66864 14.6 2 14.6H22C22.3314 14.6 22.6 14.3314 22.6 14V2C22.6 1.66862 22.3314 1.39999 22 1.39999H2Z",
  fill: "current"
});

function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.55f4530c.svg";
export { ForwardRef as ReactComponent };